const AppVersionSwitch = () => {
    return (
      <div className="tdx-app-switch" aria-label="Switch between app versions">
        <a
          href="https://app.teedex.in"
          className="tdx-app-switch__option"
          target="_blank"
          rel="noreferrer"
        >
          Teedex 2.0
        </a>
  
        <span className="tdx-app-switch__option tdx-app-switch__option--active">
          Teedex 1.3
        </span>
      </div>
    );
  };
  
  export default AppVersionSwitch;